export const DeviceInfoTab4Control = [
  {
    btnName: '重新启动该设备',
    type: 'reboot',
    listArr: [
      '检查是否被占用',
      '询问盒子收发消息是否正常',
      '等待盒子确认重启消息',
      '正在重启盒子(请稍等,重启可能需要2~3分钟)'
    ]
  },
  {
    btnName: '上报SIM卡',
    type: 'sim',
    listArr: ['检查是否被占用', '询问盒子收发消息是否正常', '等待SIM卡上报结果']
  },
  {
    btnName: '上报配置',
    type: 'config',
    listArr: ['检查是否被占用', '询问盒子收发消息是否正常', '等待配置上报结果']
  },
  {
    btnName: '上报位置',
    type: 'location',
    listArr: ['检查是否被占用', '询问盒子收发消息是否正常', '等待位置上报结果']
  },
  {
    btnName: '上报APP',
    type: 'app',
    listArr: ['检查是否被占用', '询问盒子收发消息是否正常', '等待APP上报结果']
  }
];



// WEBPACK FOOTER //
// ./src/const/DataConst.js